/* src/modules/dashboard/cards/LessonTypeCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty } from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import { Paper, Typography } from '@material-ui/core';

import { PieChart } from '../../components';
import { loadTexts } from '../../../../config/texts';
import { getLessonHelpType } from '../../selectors';
const TEXT_KEY = 'dashboard';

const LessonTypeCard = ({ lessonHelpData: { labels, data }, locale }) => {
  const texts = loadTexts(TEXT_KEY, locale);
  return (
    <Paper>
      {isEmpty(data) ? (
        <Typography>
          {texts.fields.no_data}
        </Typography>
      ) : (
        <PieChart title={texts.title.lesson_type} labels={labels} data={data} />
      )}
    </Paper>
  );
}

LessonTypeCard.propTypes = {
  lessonHelpData: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  lessonHelpData: getLessonHelpType(state),
  locale: state.appState.locale,
});

export default compose(
  withStyles(() => ({}), { name: 'LessonTypeCard' }),
  connect(mapStateToProps),
)(LessonTypeCard);



// WEBPACK FOOTER //
// ./src/modules/dashboard/cards/LessonTypeCard/index.js